import React, { useState, useContext, useEffect } from "react";
import { makeStyles } from '@mui/styles';
// import "./safewatch.scss";
import {
  InputLabel,
  FormControl,
  Select,
  MenuItem,
  Grid
} from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { getCameraSelected, setCameraSelected } from "Redux/DashboardVariables";
import { getLocationSelected, setLocationSelected } from "Redux/DashboardVariables";
import { getLocationsData } from "Redux/DashboardVariables";
import { getCameraData } from "Redux/DashboardVariables";

const useStyles1 = makeStyles({
  root: {
    width: 200,
    "& .MuiOutlinedInput-input": {
      color: "gray",
      fontFamily: 'Lato',
      fontSize: '14px'
    },
    // "& .MuiInputLabel-root": {
    //   color: "green"
    // },
    // "& .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    //   borderColor: "green"
    // },
    // "&:hover .MuiOutlinedInput-input": {
    //   color: "red"
    // },
    // "&:hover .MuiInputLabel-root": {
    //   color: "red"
    // },
    // "&:hover .MuiOutlinedInput-root .MuiOutlinedInput-notchedOutline": {
    //   borderColor: "red"
    // },
    // "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-input": {
    //   color: "purple"
    // },
    // "& .MuiInputLabel-root.Mui-focused": {
    //   color: "purple"
    // },
    // "& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline": {
    //   borderColor: "purple"
    // }
  }
});


const useStyles = makeStyles((theme) => ({
  formControl: {
    margin: "0px 8px",
    minWidth: 160,
  },
  selectEmpty: {
    marginTop: '10px',
  },
  // root: {
  //   "& .MuiOutlinedInput-input": {
  //     color: "green"
  //   }
  // }
}));

export default function LocationCameraSelect({
  style = {},
  disabled = false,
  hideCameraSelection = false
}) {
  const classes = useStyles();
  const classes1 = useStyles1();
  const dispatch = useDispatch();

  const locationsData = useSelector(getLocationsData);
  const cameraData = useSelector(getCameraData);
  const cameraSelected = useSelector(getCameraSelected);
  const locationSelected = useSelector(getLocationSelected);

  const getFilteredCameraData = () => {
    if (!cameraData) {
      return [];
    }
    if (locationSelected === '') {
      return cameraData;
    }
    return cameraData.filter(camera => camera.locationId === locationSelected);
  }

  return (
    <>
      <Grid xs={2} item style={{ margin: "10px 10px", width: '200px', ...style }}>
        <FormControl size="small" variant="outlined" fullWidth>
          <InputLabel
            id="demo-multiple-checkbox-label"
            style={{ fontFamily: 'Lato', fontSize: '14px' }}
          >
            Filter by Location
          </InputLabel>
          <Select
            // native
            className={classes1.root}
            labelId="demo-simple-select-filled-label"
            id="demo-simple-select-filled locationfilter"
            value={locationSelected}
            onChange={(e) => {
              dispatch(setLocationSelected(e.target.value));
              dispatch(setCameraSelected(''));
            }}
            label="Filter by Location"
            style={{ background: "white" }}
            inputProps={{
              name: "Filter by Location",
              id: "outlined-age-native-simple",
              style: { padding: "12px" },
            }}
            disabled={disabled}
          >
            <MenuItem
              aria-label="Locations"
              value=""
              id="All locations"
              className="menuitem"
              style={{ fontFamily: 'Lato', fontSize: '14px' }}
            >
              <em>All Locations</em>
            </MenuItem>
            {locationsData &&
              locationsData.sort((a, b) => {
                if (`${a.displayLayer1}/${a.displayLayer2}/${a.site}`
                  > `${b.displayLayer1}/${b.displayLayer2}/${b.site}`) {
                  return 1;
                }
                return -1;
              }).map((location, i) => {
                return (
                  <MenuItem
                    key={i}
                    id={`${location.displayLayer1}/${location.displayLayer2}/${location.site}`}
                    value={location.id}
                    className="menuitem"
                    style={{ fontFamily: 'Lato', fontSize: '14px' }}
                  >
                    {`${location.displayLayer1} / ${location.displayLayer2} / ${location.site}`}
                  </MenuItem>
                );
              })}
          </Select>
        </FormControl>
      </Grid>

      {
        !hideCameraSelection &&
        <Grid xs={2} item style={{ margin: "10px 10px", width: '200px', ...style }}>
          <FormControl
            variant="outlined"
            size="small"
            fullWidth
          >
            <InputLabel
              style={{ fontFamily: 'Lato', fontSize: '14px' }}
              id="demo-simple-select-filled-label">
              Filter by Camera
            </InputLabel>
            <Select
              className={classes1.root}
              // native
              labelId="demo-simple-select-filled-label"
              id="demo-simple-select-filled camerafilter"
              value={cameraSelected}
              disabled={locationSelected === ""}
              onChange={(e) => {
                dispatch(setCameraSelected(e.target.value));
              }}
              label="Filter by Camera"
              style={{ background: "white" }}
            // inputProps={{
            //   name: "Camera",
            //   id: "outlined-age-native-simple",
            // }}
            >
              <MenuItem
                aria-label="Cameras"
                value=""
                id="All Cameras"
                className="menuitem"
                style={{ fontFamily: 'Lato', fontSize: '14px' }}
              >
                <em>All Cameras</em>
              </MenuItem>
              {getFilteredCameraData().sort((a, b) => {
                if (a.name > b.name) { return 1 }
                return -1;
              }).map((camera, i) => {
                return (
                  <MenuItem
                    key={i}
                    value={camera.id}
                    id={camera.name}
                    className="menuitem"
                    style={{ fontFamily: 'Lato', fontSize: '14px' }}
                  >
                    {camera.name}
                  </MenuItem>
                );
              })}
            </Select>
          </FormControl>
        </Grid>
      }
    </>
  );
}
